import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es7.promise.finally";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations, mapState } from 'vuex';
import iconsMixin from '../state/bridge/iconsMixin';
import ApiService from '@/services/apiService';
import { downloadAttachment, isNullOrEmpty } from '@/utils/vuex';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import clone from 'lodash/clone';
import pullAt from 'lodash/pullAt';
import uniq from 'lodash/uniq';
import chunk from 'lodash/chunk';
var MAX_COPIES = 100;
export default {
  name: 'CoreDtwinDuplicateBase',
  mixins: [iconsMixin],
  props: {
    orgTwin: {
      type: Object,
      required: true
    },
    orgTwinStates: {
      type: Array,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      twinCreateFormValid: false,
      globalParentId: false,
      globalParentTwin: {},
      metaInfoToggles: {
        tags: true,
        address: false,
        geocoordinates: false,
        keyvalue: false
      },
      copiesCount: 1,
      statePickerMode: 'virtualdevices',
      twinCopiesData: [],
      errornousParentId: -1,
      loadingStates: false,
      bridgeConfigs: [],
      // only for use in text-field validator
      maxCopies: MAX_COPIES
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    pickableStates: function pickableStates() {
      var _this = this;

      return this.orgTwinStates.filter(function (state) {
        var validSourceTypes = [];

        if (_this.statePickerMode === 'iothub') {
          validSourceTypes = ['iothub', 'iothub-aggregate'];
        } else if (_this.statePickerMode === 'complete') {
          validSourceTypes = ['iothub', 'iothub-aggregate', 'bridge'];
        } else if (_this.statePickerMode === 'virtualdevices') {
          validSourceTypes = ['iothub', 'iothub-aggregate', 'virtual-device', 'virtual-device-aggregate'];
        }

        return validSourceTypes.indexOf(state.properties.binding.type) >= 0;
      });
    }
  }),
  watch: {
    copiesCount: function copiesCount() {
      this.syncCopiesData();
    },
    orgTwin: function orgTwin() {
      this.loadBridgeData();
    }
  },
  created: function created() {
    this.loadBridgeData();
    this.syncCopiesData();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    get: get,
    loadBridgeData: function loadBridgeData() {
      var _this2 = this;

      this.loadingStates = true;
      Promise.all([ApiService.getBridgeTypes(), ApiService.getBridgesForTenant(this.orgTwin.tenantId)]).then(function (configData) {
        var types = configData[0];
        var configs = configData[1];
        _this2.bridgeConfigs = configs.filter(function (config) {
          return _this2.bridgeConfig(config, types).manifest.functionScope.invokeDirection.inbound;
        }).map(function (config) {
          return {
            type: config.type,
            image: _this2.bridgeTypesIcons[config.type],
            title: config.name,
            configId: config.id,
            tenantId: config.tenantId
          };
        });
      }).catch(function (error) {
        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('DigitalTwin.DigitalTwin.twinScopeCreationFailedSnack'), 'error');
        }

        console.error(error);
      }).finally(function () {
        _this2.syncCopiesData();

        _this2.loadingStates = false;
      });
    },
    bridgeConfig: function bridgeConfig(bridge, types) {
      var foundMatch = types.find(function (config) {
        return config.type === bridge.type;
      });
      return foundMatch;
    },
    syncCopiesData: function syncCopiesData() {
      var _this3 = this;

      // during processing, put all into separate array
      var syncedData = clone(this.twinCopiesData);

      while (syncedData.length < Math.min(this.maxCopies, this.copiesCount)) {
        syncedData.push({
          id: this.twinCopiesData.length,
          parentId: this.orgTwin.parentId,
          tenantId: this.orgTwin.tenantId,
          title: "".concat(this.orgTwin.title, " copy ").concat(syncedData.length + 1),
          data: {
            faIcon: this.orgTwin.data.faIcon,
            tags: this.orgTwin.data.tags || [],
            keyValue: this.orgTwin.data.keyValue || {},
            address: {
              formatted_address: ''
            }
          },
          coordinates: {
            coordinates: [null, null]
          }
        });
      }

      syncedData.forEach(function (twin) {
        if ((twin.states || []).length === 0) {
          twin.states = cloneDeep(_this3.orgTwinStates);
        }
      });

      while (syncedData.length > Math.min(this.maxCopies, this.copiesCount)) {
        pullAt(syncedData, [syncedData.length - 1]);
      } // at the very last, copy it in the target object


      this.twinCopiesData = clone(syncedData);
    },
    twinParentFilter: function twinParentFilter(twin) {
      return !get(twin, 'properties.disabled');
    },
    updateTwinsParents: function updateTwinsParents(parentTwin) {
      this.globalParentTwin = parentTwin;
      this.$refs['duplicate-config-form'].updateTwinsParents(parentTwin);
    },
    changedDisplayOptions: function changedDisplayOptions() {
      this.metaInfoToggles = cloneDeep(this.metaInfoToggles);
    },
    cloneOrgTwinStates: function cloneOrgTwinStates() {
      this.$emit('forceRefreshStates');
      this.$refs['createForm'].validate();
    },
    randomHexString: function randomHexString(len) {
      var charSet = 'ABCDEF0123456789';
      var randomString = '';

      for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
      }

      return randomString;
    },
    downloadSampleCsv: function downloadSampleCsv() {
      var _this4 = this;

      var tagsSample = this.orgTwin.data.tags || [];

      if (tagsSample.length < 2) {
        tagsSample = ['sampletag1', 'sampletag2'].concat(tagsSample);
      }

      var coordinateSample = get(this.orgTwin, 'coordinates.coordinates') || [null, null];
      var addressSample = get(this.orgTwin, 'data.address.formatted_address') || '';
      var titleCols = ['title', 'parentId', 'tags', 'longitude', 'latitude', 'address', 'keyvalue'].concat(this.pickableStates.map(function (state) {
        return state.key;
      }));
      var pickableStatesDemoData = this.pickableStates.map(function (s) {
        if (s.properties.binding.type.startsWith('iothub')) {
          return _this4.randomHexString(16);
        } else {
          return "EXT_ID_".concat(_this4.randomHexString(16));
        }
      });
      var keyvalueDemoDataObj = Object.keys(this.orgTwin.data.keyValue || {}).length === 0 ? {
        key1: 'value1'
      } : this.orgTwin.data.keyValue;
      var keyvalueDemoData = Object.keys(keyvalueDemoDataObj).map(function (key) {
        return "".concat(key, ": ").concat(keyvalueDemoDataObj[key]);
      });
      var colSeparator = ',';
      var csvData = ["".concat(titleCols.join(colSeparator)), "".concat([// cannot have a comma in the title screw up all indices; the user probably won't know what is going on either
      "\"".concat(this.orgTwin.title, "\""), this.orgTwin.parentId, "\"".concat(tagsSample.join(colSeparator), "\""), coordinateSample[0], coordinateSample[1], addressSample === '' ? '' : "\"".concat(addressSample, "\""), "\"".concat(keyvalueDemoData.join(colSeparator), "\"")].join(colSeparator)).concat(colSeparator).concat(pickableStatesDemoData.join(colSeparator))].join('\n');
      var fileName = 'bulk-create-twins.csv';
      downloadAttachment('text/plain;charset=utf-8', csvData, fileName);
    },
    uploadedFile: function () {
      var _uploadedFile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(csv) {
        var _this5 = this;

        var lines, csvToArray, handleInnerStringSplit, colSeparator, tagSeparator, newTwinCopiesData, header, n1Euis, n2VDeviceDetails;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                handleInnerStringSplit = function _handleInnerStringSpl(inputString, colSeparator, tagSeparator) {
                  var usedSplitted = inputString.split(tagSeparator);

                  if (usedSplitted.length <= 1) {
                    var otherTagSeparator = inputString.split(colSeparator);

                    if (otherTagSeparator.length > usedSplitted.length) {
                      usedSplitted = otherTagSeparator;
                    }
                  }

                  return usedSplitted;
                };

                csvToArray = function _csvToArray(text) {
                  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
                  // adapted to support either comma or semilicon as separators
                  // had to do a lot of ugly escaping, so it looks even more horrid than the original Regex
                  // eslint-disable-next-line max-len
                  var re_valid = new RegExp("^\\s*(?:'[^'\\\\]*(?:\\\\[\\S\\s][^'\\\\]*)*'|\"[^\"\\\\]*(?:\\\\[\\S\\s][^\"\\\\]*)*\"|[^".concat(separator, "'\"\\s\\\\]*(?:\\s+[^").concat(separator, "'\"\\s\\\\]+)*)\\s*(?:").concat(separator, "\\s*(?:'[^'\\\\]*(?:\\\\[\\S\\s][^'\\\\]*)*'|\"[^\"\\\\]*(?:\\\\[\\S\\s][^\"\\\\]*)*\"|[^").concat(separator, "'\"\\s\\\\]*(?:\\s+[^").concat(separator, "'\"\\s\\\\]+)*)\\s*)*$"));
                  var re_value = new RegExp("(?!\\s*$)\\s*(?:'([^'\\\\]*(?:\\\\[\\S\\s][^'\\\\]*)*)'|\"([^\"\\\\]*(?:\\\\[\\S\\s][^\"\\\\]*)*)\"|([^".concat(separator, "'\"\\s\\\\]*(?:\\s+[^").concat(separator, "'\"\\s\\\\]+)*))\\s*(?:").concat(separator, "|$)"), 'g'); // Return NULL if input string is not well formed CSV string.

                  if (!re_valid.test(text)) {
                    return null;
                  }

                  var a = []; // Initialize array to receive values.

                  text.replace(re_value, // "Walk" the string using replace with callback.
                  function (m0, m1, m2, m3) {
                    // Remove backslash from \' in single quoted values.
                    if (m1 !== undefined) {
                      a.push(m1.replace(/\\'/g, "'"));
                    } else if (m2 !== undefined) {
                      // Remove backslash from \" in double quoted values.
                      a.push(m2.replace(/\\"/g, '"'));
                    } else if (m3 !== undefined) {
                      a.push(m3);
                    }

                    return ''; // Return empty string.
                  }); // Handle special case of empty last value.

                  if (new RegExp("".concat(separator, "\\s*$")).test(text)) {
                    a.push('');
                  }

                  return a;
                };

                lines = csv.split('\n');

                if (!(lines.length <= 1)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                colSeparator = ',';
                tagSeparator = /[;|]/;
                newTwinCopiesData = [];
                header = csvToArray(lines[0].trim(), colSeparator);

                if (header.length < 3 + this.pickableStates.length) {
                  colSeparator = ';';
                  tagSeparator = /[,|]/;
                  header = csvToArray(lines[0].trim(), colSeparator);
                }

                header = header.slice(3);
                pullAt(lines, [0]);
                n1Euis = [];
                n2VDeviceDetails = []; // eslint-disable-next-line max-statements

                lines.forEach(function (line) {
                  var parts = csvToArray(line.trim(), colSeparator); // 0 = title, 1 = parentId, 2 = tags, 3++ = state-key EUIs

                  if (!parts || parts.length < 3 + _this5.pickableStates.length || newTwinCopiesData.length >= _this5.maxCopies) {
                    // not a complete data-set, ignore current line
                    return;
                  }

                  var copiedStates = cloneDeep(_this5.orgTwinStates);
                  copiedStates.forEach(function (state) {
                    // extract info from CSV for configurable states, aka iot-hub or virtual-devices
                    // load all their data for UI-side verification
                    var pickableState = _this5.pickableStates.find(function (s) {
                      return s.key === state.key;
                    });

                    if (!pickableState) {
                      return;
                    } // use "lastIndexOf" rather than "findIndex" in case that states are named "latitude"/"longitude"
                    // since those are in the original CSV already for the coordinates, do not confuse the script


                    var stateCsvIndex = header.lastIndexOf(state.key);

                    if (stateCsvIndex >= 0) {
                      var csvContent = parts[3 + stateCsvIndex];

                      if (pickableState.properties.binding.type.startsWith('iothub')) {
                        // #### iothub states
                        state.properties.binding.options.eui = csvContent;
                        n1Euis.push(csvContent);
                      } else if (pickableState.properties.binding.type.startsWith('virtual-device')) {
                        // special cases to overwrite the state-source-type via CSV
                        if (csvContent.toLowerCase() === 'none') {
                          state.properties.binding.type = 'none';
                          state.properties.vdExternalId = "".concat(_this5.$i18n_t('DigitalTwin.DigitalTwin.states.copy.sourceType'), ": ").concat(_this5.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.none'));
                        } else if (csvContent.toLowerCase() === 'null') {
                          state.properties.binding.type = 'no-copy';
                          state.properties.vdExternalId = _this5.$i18n_t('DigitalTwin.DigitalTwin.copy.noStateCopy');
                        } else {
                          // #### virtual device states
                          if (!get(state, 'properties.binding.options.virtualDevice')) {
                            state.properties.binding.options = _objectSpread(_objectSpread({}, state.properties.binding.options), {}, {
                              virtualDevice: {}
                            });
                          }

                          var fetchOptions = _this5.$refs['duplicate-config-form'].fetchOptionsFromVDState(pickableState);

                          fetchOptions.id = csvContent;
                          state.properties.binding.options.virtualDevice.vdExternalId = fetchOptions.id;
                          n2VDeviceDetails.push(fetchOptions);
                        }
                      }
                    }
                  });
                  var titleIndex = 0;
                  var parentIndex = 1;
                  var tagsIndex = 2;
                  var usedTags = handleInnerStringSplit(parts[tagsIndex].trim(), colSeparator, tagSeparator);

                  if (usedTags) {
                    _this5.metaInfoToggles.tags = true;
                  }

                  var twinCopyData = {
                    id: newTwinCopiesData.length,
                    title: parts[titleIndex].trim() === '' ? undefined : parts[titleIndex].trim(),
                    parentId: parseInt(parts[parentIndex].trim()) || _this5.orgTwin.parentId,
                    tenantId: _this5.orgTwin.tenantId,
                    data: {
                      faIcon: _this5.orgTwin.data.faIcon,
                      tags: usedTags || _this5.orgTwin.data.tags || [],
                      keyValue: _this5.orgTwin.data.keyValue || {},
                      address: {
                        formatted_address: ''
                      }
                    },
                    coordinates: {
                      coordinates: [null, null]
                    },
                    states: copiedStates
                  };

                  if (header.length > 3) {
                    // extract geo-data
                    var latIndex = header.findIndex(function (key) {
                      return key.toLowerCase().startsWith('lat');
                    });
                    var lonIndex = header.findIndex(function (key) {
                      return key.toLowerCase().startsWith('lon');
                    });
                    var addressIndex = header.findIndex(function (key) {
                      return key.toLowerCase().startsWith('address');
                    });

                    if (latIndex >= 0 && latIndex <= 1 && lonIndex >= 0 && lonIndex <= 1) {
                      if (!isNaN(parseFloat(parts[3 + lonIndex])) && !isNaN(parseFloat(parts[3 + latIndex]))) {
                        twinCopyData.coordinates = {
                          coordinates: [parseFloat(parts[3 + lonIndex]), parseFloat(parts[3 + latIndex])]
                        };
                        _this5.metaInfoToggles.geocoordinates = true; // reset the polygon, in order for the backend to create a default-polygon around the coordinates

                        twinCopyData.polygon = null;
                      }
                    }

                    if (addressIndex >= 0) {
                      twinCopyData.data.address = {
                        // make the address nice again, by inserting commas where the alternative-separators were
                        formatted_address: handleInnerStringSplit(parts[3 + addressIndex].trim(), colSeparator, tagSeparator).join(', ')
                      };
                      _this5.metaInfoToggles.address = true;
                    } else {
                      twinCopyData.data.address = {
                        formatted_address: ''
                      };
                    }

                    var hasKeyValueData = false; // extract key-value data

                    var keyValueIndex = header.findIndex(function (key) {
                      return key.toLowerCase() === 'keyvalue';
                    });

                    if (keyValueIndex >= 0) {
                      twinCopyData.data.keyValue = {};
                      var keyValueParts = handleInnerStringSplit(parts[3 + keyValueIndex].trim(), colSeparator, tagSeparator);
                      keyValueParts.forEach(function (kv) {
                        var kvParts = kv.trim().split(':');

                        if (kvParts.length >= 2) {
                          twinCopyData.data.keyValue[kvParts[0].trim()] = kvParts[1].trim();
                          hasKeyValueData = true;
                        }
                      });
                    }

                    if (hasKeyValueData) {
                      _this5.metaInfoToggles.keyvalue = true;
                    }
                  }

                  newTwinCopiesData.push(twinCopyData);
                });
                this.twinCopiesData = newTwinCopiesData;
                this.copiesCount = newTwinCopiesData.length;
                this.loadingStates = true;
                _context.next = 20;
                return this.fetchIotHubEuis(n1Euis);

              case 20:
                if (!(this.statePickerMode === 'virtualdevices')) {
                  _context.next = 23;
                  break;
                }

                _context.next = 23;
                return this.fetchVirtualDeviceDetails(n2VDeviceDetails);

              case 23:
                this.loadingStates = false;
                this.cloneOrgTwinStates();

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadedFile(_x) {
        return _uploadedFile.apply(this, arguments);
      }

      return uploadedFile;
    }(),
    fetchIotHubEuis: function () {
      var _fetchIotHubEuis = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(n1Euis) {
        var _this6 = this;

        var fetchEuis, i;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // TODO: would be noice to search for multiple EUIs at once (comma-separated?)
                // for now, chunk the unique EUIs in buckets of 10 and fire 10 requests at once at a time
                fetchEuis = chunk(uniq(n1Euis), 10);
                i = 0;

              case 2:
                if (!(i < fetchEuis.length)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 5;
                return Promise.all(fetchEuis[i].map(function (eui) {
                  return _this6.$refs['duplicate-config-form'].fetchIotHubDeviceDetails(eui);
                }));

              case 5:
                i++;
                _context3.next = 2;
                break;

              case 8:
                _context3.next = 10;
                return Promise.all(this.twinCopiesData.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(twin) {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return Promise.all(twin.states.map(function (state) {
                              // all EUI-search-results are cached, so now wire the states up with their result
                              return _this6.$refs['duplicate-config-form'].fetchIotHubDetails(state, twin, false);
                            }));

                          case 2:
                            twin.states = cloneDeep(twin.states);

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchIotHubEuis(_x2) {
        return _fetchIotHubEuis.apply(this, arguments);
      }

      return fetchIotHubEuis;
    }(),
    fetchVirtualDeviceDetails: function () {
      var _fetchVirtualDeviceDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(n2VDeviceDetails) {
        var _this7 = this;

        var fetchDetails, i;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                fetchDetails = chunk(uniq(n2VDeviceDetails), 10);
                i = 0;

              case 2:
                if (!(i < fetchDetails.length)) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 5;
                return Promise.all(fetchDetails[i].map(function (details) {
                  return _this7.$refs['duplicate-config-form'].fetchVirtualDeviceDataDetails(details);
                }));

              case 5:
                i++;
                _context5.next = 2;
                break;

              case 8:
                _context5.next = 10;
                return Promise.all(this.twinCopiesData.map( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(twin) {
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return Promise.all(twin.states.map(function (state) {
                              // all search-results are cached, so now wire the states up with their result
                              return _this7.$refs['duplicate-config-form'].fetchVirtualDeviceData(state, twin, false);
                            }));

                          case 2:
                            twin.states = cloneDeep(twin.states);

                          case 3:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x5) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchVirtualDeviceDetails(_x4) {
        return _fetchVirtualDeviceDetails.apply(this, arguments);
      }

      return fetchVirtualDeviceDetails;
    }(),
    createCopies: function createCopies() {
      var _this8 = this;

      var twinCreationData = cloneDeep(this.twinCopiesData);
      twinCreationData.forEach(function (twin) {
        if (isNullOrEmpty(get(twin, 'coordinates.coordinates[0]')) || isNullOrEmpty(get(twin, 'coordinates.coordinates[1]'))) {
          twin.coordinates = null;
        }

        twin.states = twin.states.map(function (state) {
          // do not persist temp form details
          delete state.deviceTitle;
          delete state.properties.binding.options.eui;
          delete state.properties.vdExternalId; // cleanup virtual-device data

          if (get(state, 'properties.binding.options.virtualDevice.vDeviceId')) {
            // first copy data to its target place
            state.properties.binding.options.virtualDevice.id = parseInt(state.properties.binding.options.virtualDevice.vDeviceId);
            state.properties.binding.options.virtualDevice.stateId = parseInt(state.properties.binding.options.virtualDevice.vDeviceStateId); // then cleanup

            delete state.properties.binding.options.virtualDevice.vDeviceId;
            delete state.properties.binding.options.virtualDevice.vdExternalId;
            delete state.properties.binding.options.virtualDevice.vDeviceStateId;
            delete state.properties.binding.options.virtualDevice.vDeviceKey;
          }

          if (get(state, 'properties.binding.type') === 'none') {
            state.properties.binding = {
              type: 'none',
              options: {
                aggregateStateBindingIds: []
              }
            };
          }

          if (get(state, 'properties.binding.type') === 'no-copy') {
            state.properties.binding.type = 'none'; // mark as state that should not be copied
            // we can not simply filter the state out, as the duplicate feature will just copy a state as-is if not specified
            // as we do not want to introduce a new binding-type 'no-copy' in the backend for validation,
            // use this flag instead to filter out this state on backend-side

            state.properties.doNotCopy = true;
            state.properties.binding = {
              type: 'none',
              options: {
                aggregateStateBindingIds: []
              }
            };
          }

          state.title = state.properties.title;
          state.bindingConfig = state.properties.binding; // cleanup DB-attributes

          delete state.bindingIdentifier;
          delete state.bindingType;
          delete state.bindingVariable;
          delete state.configId;
          return state;
        });
      });
      ApiService.digitalTwinDuplicate(this.orgTwin.id, twinCreationData).then(function () {
        _this8.$snack(_this8.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.jobStarted'), 'success');

        _this8.$emit('close');
      }).catch(function (error) {
        console.error('Error duplicating twin', error.response);

        if (error.code === 'ECONNABORTED') {
          _this8.$snack(_this8.$i18n_t('DigitalTwin.DigitalTwin.copy.timeoutSnack'), 'error');

          return;
        }

        _this8.$snack(_this8.$i18n_t('DigitalTwin.DigitalTwin.copy.failedSnack'), 'error');

        if (get(error, 'response.status') === 403 && get(error, 'response.data.data.twinId')) {
          _this8.errornousParentId = parseInt(get(error, 'response.data.data.twinId'));
          return;
        }

        if (get(error, 'response.status') === 404 && get(error, 'response.data.data.twinId')) {
          _this8.errornousParentId = parseInt(get(error, 'response.data.data.twinId'));
          return;
        }
      });
    }
  })
};